import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { styled } from '@mui/material/styles';
//
import LoadingOverlay from 'react-loading-overlay';
import Header from './header';
import Nav from './nav';

LoadingOverlay.propTypes = undefined


// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const general = useSelector((state) => state.general);
  return (
    <StyledRoot>
      <LoadingOverlay
        active={general.loading}
        spinner
        styles={{
          wrapper: (base) => ({
            ...base,
            overflow: general.loading ? 'hidden' : 'scroll',
            position: 'fixed',
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: general.loading ? 'block' : 'none',
          }),
          content: (base) => ({
            ...base,
          }),
        }}
      />
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
